var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg404 = function Svg404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 880 350"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#404_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 439.953,
    cy: 175,
    r: 175,
    fill: "#E2DE2E",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#404_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2DE2E",
    fillOpacity: 0.1,
    d: "M143.38 350v-88.318H0v-31.075L159.735 0h53.427v221.34h51.791v40.342h-51.791V350zM23.988 221.34H143.38V49.61z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#404_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2DE2E",
    fillOpacity: 0.1,
    d: "M758.333 350v-88.318h-143.38v-31.075L774.688 0h53.427v221.34h51.791v40.342h-51.791V350zM638.941 221.34h119.392V49.61z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "404_svg__a",
    width: 362,
    height: 362,
    x: 258.953,
    y: -6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1399_7098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1399_7098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "404_svg__b",
    width: 276.953,
    height: 362,
    x: -6,
    y: -6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1399_7098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1399_7098",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "404_svg__c",
    width: 276.953,
    height: 362,
    x: 608.953,
    y: -6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1399_7098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1399_7098",
    result: "shape"
  })))));
};
export default Svg404;